import React from 'react';
import { useEffect, useState } from "react";
import Page from '../../components/Page';
import {
    Box,
    Typography,
    Button,
    Hidden,
    Modal,
} from '@mui/material';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport
} from '@mui/x-data-grid';
import NotesModal from '../licensing/LicensingInfoModal';
import { useLicenses } from '../../hooks/useLicenses';
import {
    createLicenseActivationColumn,
    createLicenseDurationColumn,
    createLicenseExpirationColumn,
    createLicenseStatusColumn,
    licenseTableInitialState,
} from '../licensing/licenseTableColumns';
import { useAdminCompany } from '../../context/AdminCompanyContext';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const CompanyLicenseDataGrid = () => {
    /// Company data grid for super admins shows all registered companies
    const [rowItem, setRowItem] = useState();
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);
    const [open2, setOpen2] = React.useState(false);
    const handleClose2 = () => setOpen2(false);

    const { companyData } = useAdminCompany();
    const { data: licensesData = [] } = useLicenses({
        companyId: companyData?.id,
        type: '1',
        enabled: Boolean(companyData?.id),
    });

    function showInfo(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            id: cellValues.row.id,
            licenseNumber: cellValues.row.licenseNumber,
            used: cellValues.row.used,
            userId: cellValues.row.userId,
            licenseUserName: `${cellValues.row.userFN} ${cellValues.row.userLN}`,
            licenseCreated: cellValues.row.licenseCreated,
            licenseUpdated: cellValues.row.licenseUpdated,
            licenseExpiration: cellValues.row.licenseExpiration,
            licenseActivation: cellValues.row.licenseActivation,
            notes: cellValues.row.notes,
        })
        handleOpen1();
    };

    const licenseReadableData = licensesData.map(license => {
        return {
            ...license,
            licenseUserName: `${license.userFN} ${license.userLN}`,
        }
    })

    const columns = [
        { field: 'licenseNumber', headerName: 'License #', width: 300, headerClassName: 'header' },
        createLicenseStatusColumn(),
        { field: 'licenseUserName', headerName: 'User', width: 175, headerClassName: 'header',
            renderCell: (cellValues) => {
                if(cellValues.row.licenseUserName == `null null`){
                    return "N/A"
                } else {
                    return cellValues.row.licenseUserName
                }
            }
        },
        { field: 'licenseCreated', headerName: 'Generated Date', width: 125, headerClassName: 'header',
            renderCell: (params) => {
            let date = new Date(params.row.licenseCreated);
            const options = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              };
            return date.toLocaleString("en-US",options)
        }},
        createLicenseActivationColumn(),
        createLicenseExpirationColumn(),
        createLicenseDurationColumn(),
        { field: 'notes', headerName: 'Notes', width: 200, headerClassName: 'header',
            renderCell: (cellValues) => {
                if(cellValues.row.notes != null){
                    return(<Button onClick={() => showInfo(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis', }}>{cellValues.row.notes}</Button>)
                } else {
                    return(<Button onClick={() => showInfo(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis'}}>No Notes</Button>)
                }
            }
        }
    ];

    const rows = licenseReadableData;

    let screenWidth = window.screen.width;

    useEffect(() => {
        screenWidth = window.screen.width;
    }, [licensesData],[screenWidth]);

    return (
        <div sx={{height: "100%"}}>
            {/* {screenWidth > 1000 ? */}
                <Box p={3} sx={{ '& .header': { backgroundColor: '#e2e2e2' }, height: "100%" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant='h3' textAlign='left' p={2}>
                            Licenses
                        </Typography>
                    </Box>
                    <DataGrid
                        columns={columns}
                        rows={rows}
                        initialState={licenseTableInitialState}
                        style={{textAlign:'left', height:'70vh'}}
                    />
                    <Modal
                        open={open1}
                        onClose={handleClose1}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <NotesModal updateType={1} item={rowItem} style={style} handleClose1={handleClose1} handleClose2={handleClose2}/>
                    </Modal>
                </Box>
            {/* //     :
            //     <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
            //         {licenseReadableData.map(item => (
            //             <div style={{border: 'solid black 2px', marginTop:'5px', padding: '5px', textAlign:'left', width:'75%'}}>
            //                 <span style={{}}>Customer:
            //                     {item.licenseUserName != `null null` ?
            //                     <span> {item.licenseUserName}</span>
            //                     :
            //                     <span> Not Assigned</span>
            //                     }
            //                 </span>
            //                 <br/>
            //                 <span>License #: {item.licenseNumber}</span>
            //                 <br/>
            //                 <span>Days: {item.expirationLength}</span>
            //             </div>
            //         ))
            //         }
            //     </div>
            // } */}
        </div>
    )
};

export default CompanyLicenseDataGrid;